import { FC } from 'react';
import { Flex, FlexProps } from '@chakra-ui/react';

/**
 * A box designed for the main content of the OBCardRow.
 */
const Body: FC<FlexProps> = ({ children, ...props }) => (
  <Flex
    align="left"
    direction="column"
    paddingY="space-8"
    textAlign="left"
    whiteSpace="pre-wrap"
    {...props}
  >
    {children}
  </Flex>
);

export default Body;
